<template>
  <div class="collection-card">
    <div class="collection-info">
      <h3 class="collection-name">{{ name }}</h3>
      <p class="collection-description" v-if="description">{{ description }}</p>
      <p class="collection-size" v-if="size">{{ size }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CollectionCard',
  props: {
    name: { type: String, required: true },
    description: { type: String, default: '' },
    size: { type: String, default: '' }
  }
}
</script>

<style scoped>
.collection-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: #E5D5BB;
  border-radius: 12px;
  box-sizing: border-box;
  padding: 15px;
  text-align: left;
  width: 100%;
  max-width: 200px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  font-weight: bold;
  min-height: 120px;
}

.collection-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}

.collection-name {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin: 0;
}

.collection-description {
  font-size: 12px;
  color: #666;
  margin: 0;
  line-height: 1.4;
}

.collection-size {
  font-size: 14px;
  color: #876C43;
  font-weight: 600;
  margin: 0;
}

@media (max-width: 768px) {
  .collection-card {
    max-width: 100%;
  }
}
</style>
